/**
 * LegacyControlCenterRedirect — Tier 2B redirect shim.
 *
 * The standalone `/events/:eventId/control-center` route is deprecated in
 * favor of the canonical `/event/:eventId?section=control` workspace tab.
 *
 * This component:
 *   1. Fires a non-blocking POST to `/api/control-center/legacy-redirect-hit`
 *      so we can monitor residual traffic before fully removing the route
 *      in Tier 2D.
 *   2. Redirects the browser to the canonical URL via <Navigate replace />.
 *
 * Strict scope: NO behavior changes, NO UI changes, NO data flow changes.
 * The original EventControlCenter component is unchanged and still rendered
 * via the embedded workspace tab path.
 */
import React, { useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import apiClient from '../services/apiClient';

const LegacyControlCenterRedirect = () => {
  const { eventId } = useParams();

  useEffect(() => {
    // Fire-and-forget tracking ping. Never blocks the redirect.
    try {
      apiClient.post('/control-center/legacy-redirect-hit', {
        eventId: eventId || '',
        referrer: typeof document !== 'undefined' ? document.referrer || '' : '',
        userAgent: typeof navigator !== 'undefined' ? navigator.userAgent || '' : '',
      }).catch(() => { /* tracking is best-effort */ });
    } catch (_) { /* never throw from a redirect */ }
  }, [eventId]);

  return <Navigate to={`/event/${eventId}?section=control`} replace />;
};

export default LegacyControlCenterRedirect;
